import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, CircularProgress, NoSsr } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Users } from "lucide-react";
const gridClassOverrides = {
    "& .MuiDataGrid-columnHeader": {
        padding: "0 16px"
    },
    "& .MuiDataGrid-cell": {
        padding: "0 16px"
    },
    "& .MuiDataGrid-row:hover": {
        backgroundColor: "rgba(0, 0, 0, 0.04)"
    }
};
export const OrganizationMembersCard = ({ users, isLoading, error, columns, onRetry })=>{
    return /*#__PURE__*/ _jsxs("section", {
        children: [
            /*#__PURE__*/ _jsx("h2", {
                className: "mb-3 text-lg font-semibold text-gray-900",
                children: "Team Members"
            }),
            isLoading ? /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-col items-center py-8",
                children: [
                    /*#__PURE__*/ _jsx(CircularProgress, {}),
                    /*#__PURE__*/ _jsx("p", {
                        className: "mt-2 text-sm text-gray-500",
                        children: "Loading team members..."
                    })
                ]
            }) : error ? /*#__PURE__*/ _jsxs("div", {
                className: "py-8 text-center",
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "text-sm text-red-600",
                        children: error instanceof Error ? error.message : String(error)
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        onClick: onRetry,
                        className: "mt-2 text-sm text-navy-90 hover:text-navy-70",
                        children: "Try again"
                    })
                ]
            }) : users.length === 0 ? /*#__PURE__*/ _jsxs("div", {
                className: "py-8 text-center",
                children: [
                    /*#__PURE__*/ _jsx(Users, {
                        className: "mx-auto h-12 w-12 text-gray-300"
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "mt-2 text-sm text-gray-500",
                        children: "No team members found"
                    })
                ]
            }) : /*#__PURE__*/ _jsx(Box, {
                sx: {
                    height: 400,
                    width: "100%"
                },
                children: /*#__PURE__*/ _jsx(NoSsr, {
                    children: /*#__PURE__*/ _jsx(DataGrid, {
                        rows: users.map((user)=>({
                                ...user,
                                id: user.UserId
                            })),
                        columns: columns,
                        disableColumnMenu: true,
                        hideFooter: true,
                        disableRowSelectionOnClick: true,
                        sx: gridClassOverrides,
                        loading: isLoading
                    })
                })
            })
        ]
    });
};
export default OrganizationMembersCard;
